import React from 'react';
import './loader.component.scss';

interface IProps {
    readonly isActive?: boolean;
    readonly className?: string;
}
interface IState {}

export default class LoaderComponent extends React.PureComponent<IProps, IState> {
    public static defaultProps: IProps = {
        isActive: false,
        className: '',
    };

    public render(): JSX.Element {
        const { isActive, className } = this.props;

        return (
            <div className={`main__wrap-loader ${className ? className : ''}`}>
                {isActive && <img src={require('../../assets/media/img/loading/loading.gif')} alt="loader" width="95" />}
            </div>
        );
    }
}
